import { render, staticRenderFns } from "./Friendlink.vue?vue&type=template&id=387cae48&scoped=true&"
import script from "./Friendlink.vue?vue&type=script&lang=js&"
export * from "./Friendlink.vue?vue&type=script&lang=js&"
import style0 from "./Friendlink.vue?vue&type=style&index=0&id=387cae48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387cae48",
  null
  
)

export default component.exports